"use client";

// src/components/default/apple-login.tsx
import * as React from "react";
import { useUID } from "@stepstone-genesis/uid-library";
import { systemForwardRef } from "@stepstone-genesis/system";
import {
  IconContainer
} from "@stepstone-genesis/icon-containers";
var AppleLoginIcon = systemForwardRef(
  function IconWrapper({ title, id, display, size, color, ...rest }, ref) {
    const identifier = useUID();
    const titleId = title ? `AppleLoginIcon-${id != null ? id : identifier}` : void 0;
    const role = title ? "img" : "presentation";
    const componentName = `AppleLoginIcon`;
    return /* @__PURE__ */ React.createElement(
      IconContainer,
      {
        ...rest,
        display,
        size,
        color,
        ref
      },
      /* @__PURE__ */ React.createElement(
        "svg",
        {
          "data-genesis-element": componentName,
          role,
          width: "100%",
          height: "100%",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-labelledby": titleId
        },
        title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
        /* @__PURE__ */ React.createElement(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.5493 0.0081528C9.87424 0.0732422 9.08166 0.464443 8.52557 1.00704C7.93066 1.58753 7.52865 2.39446 7.45817 3.14956C7.44735 3.26552 7.45232 3.54145 7.46663 3.61854L7.4763 3.67062L7.54329 3.68014C7.64107 3.69403 7.88171 3.68568 8.00532 3.66412C8.47701 3.58184 8.96825 3.34958 9.40729 3.00127C9.54003 2.89596 9.78549 2.64742 9.90634 2.49596C10.0822 2.27551 10.2316 2.03992 10.3521 1.79271C10.5277 1.43267 10.6318 1.09208 10.6887 0.690959C10.7051 0.575032 10.7127 0.213821 10.7006 0.120547C10.684 -0.00824067 10.6871 -0.000715925 10.6502 0.000487409C10.6325 0.00106563 10.5871 0.00451936 10.5493 0.0081528ZM10.2469 3.87271C10.0651 3.88344 9.81859 3.9232 9.60255 3.97661C9.31813 4.04693 9.10471 4.1195 8.60281 4.31654C8.19561 4.4764 8.06931 4.52093 7.9055 4.56243C7.69768 4.61506 7.51538 4.61375 7.29066 4.558C7.13154 4.51853 7.01527 4.47717 6.59706 4.31128C6.19462 4.15164 6.04788 4.09849 5.85744 4.04338C5.39372 3.9092 5.02367 3.87935 4.55701 3.93847C4.05383 4.00221 3.56699 4.16905 3.1277 4.42826C2.27365 4.93222 1.63561 5.74616 1.29206 6.76993C1.03833 7.52608 0.94949 8.38326 1.02723 9.32527C1.09843 10.1878 1.30919 11.1033 1.63613 11.9703C1.84599 12.5267 2.1298 13.1129 2.41167 13.5721C2.66937 13.9919 3.18878 14.6968 3.51148 15.0645C4.11172 15.7487 4.66842 16.04 5.29045 15.9956C5.61796 15.9722 5.82562 15.9138 6.32978 15.7034C6.65501 15.5676 6.79084 15.5168 6.95906 15.4682C7.46768 15.321 8.04241 15.3081 8.54033 15.4326C8.74871 15.4847 8.86866 15.5281 9.22374 15.6798C9.66418 15.8681 9.83289 15.9213 10.1102 15.9594C10.2334 15.9763 10.4974 15.9828 10.6023 15.9716C11.087 15.9197 11.5293 15.6789 11.9693 15.2275C12.2378 14.952 12.5095 14.6057 12.9001 14.0409C13.3307 13.4183 13.7142 12.6581 13.9526 11.9546C14.025 11.7408 14.0255 11.7388 14.0022 11.7316C13.9236 11.7073 13.6228 11.5421 13.4648 11.4365C12.5622 10.8333 12.0172 9.96363 11.8994 8.93848C11.8015 8.08579 11.9895 7.27479 12.4455 6.5826C12.7099 6.18136 13.0919 5.79876 13.5019 5.52462C13.5545 5.48944 13.5976 5.45685 13.5976 5.45223C13.5976 5.439 13.4904 5.29544 13.3973 5.18404C12.7391 4.39636 11.8089 3.94373 10.7077 3.87536C10.5892 3.868 10.3501 3.86663 10.2469 3.87271Z"
          }
        )
      )
    );
  }
);
export {
  AppleLoginIcon
};
